<div #overlay class="overlay">
    <div class="content center-content">
        <div class="header-container">
            <ng-container *ngIf="!isEditing && !isDuplicating">
                <div class="form-label" data-cy="vessel-modal-new-vessel-header">
                    {{ 'vessel.create.dialog.label' | translate }}
                </div>
            </ng-container>
            <ng-container *ngIf="isEditing">
                <div class="form-label" data-cy="vessel-modal-edit-vessel-header">
                    {{ 'vessel.edit.dialog.label' | translate }}
                </div>
            </ng-container>
            <ng-container *ngIf="isDuplicating">
                <div class="form-label" data-cy="vessel-modal-duplicate-vessel-header">
                    {{ 'vessel.duplicate.dialog.label' | translate }}
                </div>
            </ng-container>
            <div *ngIf="!canEditAll" class="cancel-button" data-cy="vessel-modal-cancel-button" (click)="clearForm()">
                {{ 'vessel.create.dialog.close' | translate }}
            </div>
        </div>
        <div>
            <ng-container *ngIf="!isEditing && !isDuplicating">
                <ng-container *ngIf="createOption === UndefinedOption">
                    <div class="column-flex">
                        <app-new-vessel-option
                            [option]="BeginningOption"
                            (onOptionSelected)="handleOptionSelected($event)"></app-new-vessel-option>
                        <app-new-vessel-option
                            [option]="RepurposeOption"
                            (onOptionSelected)="handleOptionSelected($event)"></app-new-vessel-option>
                    </div>
                </ng-container>
                <ng-container *ngIf="createOption === BeginningOption">
                    <div class="column-flex">
                        <div class="beginning-option-label" data-cy="vessel-modal-start-from-beginning-header">
                            {{ 'vessel.create.option.beginning.button' | translate }}
                        </div>
                        <ng-container *ngTemplateOutlet="vesselData"></ng-container>
                    </div>

                    <ng-container *ngTemplateOutlet="buttonsContainer"></ng-container>
                </ng-container>
                <ng-container *ngIf="createOption === RepurposeOption">
                    <div class="column-flex">
                        <app-new-vessel-template-option
                            style="padding-bottom: 18px"
                            [shipyardList]="shipyardList"
                            (onTemplateSelected)="handleSelectedVessel($event)"
                            (onLoadingVessel)="loadingVesselVersion = $event"
                            (onCloseDialog)="clearForm()"
                            (onReferenceSelected)="handleReferenceSelected($event)"></app-new-vessel-template-option>

                        <ng-container *ngIf="showVesselData">
                            <ng-container *ngIf="loadingVesselVersion; else vesselData">
                                <app-loading-spinner [smallSize]="true"></app-loading-spinner>
                            </ng-container>
                        </ng-container>
                    </div>

                    <ng-container *ngTemplateOutlet="buttonsContainer"></ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="isEditing || isDuplicating">
                <div class="column-flex">
                    <ng-container *ngTemplateOutlet="vesselData"></ng-container>
                </div>
                <ng-container *ngTemplateOutlet="buttonsContainer"></ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #vesselData>
    <form class="input-form" *ngIf="!isEditing">
        <app-input-select-with-error
            [initialValue]="selectedShipyard ? selectedShipyard : null"
            [inputValue]="selectedShipyard"
            [placeholder]="'recent.projects-access.filter.shipyards.title'"
            [maxLength]="20"
            [legend]="'vessel.create.dialog.form.shipyard'"
            [propertyName]="'shipyardId'"
            [validatorFunction]="validatorFunction()"
            [optionsArray]="shipyardList"
            [valueKey]="'id'"
            [displayKey]="'name'"
            (onInputUpdated)="handleShipyardSelected($event)"
            [disabled]="isDuplicating"></app-input-select-with-error>
    </form>
    <form class="input-form">
        <app-channel-text-input
            #inputElement
            [value]="vesselNumber"
            [label]="'vessel.create.dialog.form.number'"
            [name]="NUMBER"
            [inputError]="validationErrors?.number"
            [isDisabled]="!canEditAll && isEditing && !isDuplicating"
            (onInputChange)="onInputChange($event)"
            (onFocusChange)="onInputChange($event)"
            [maxLength]="16"></app-channel-text-input>
    </form>
    <form class="input-form">
        <app-channel-text-input
            #inputElement
            [value]="vesselName"
            [label]="'vessel.create.dialog.form.name'"
            [name]="NAME"
            [inputError]="validationErrors?.name"
            [isDisabled]="!canEditAll && !isOwner && !isDuplicating"
            (onInputChange)="onInputChange($event)"
            (onFocusChange)="onInputChange($event)"
            [maxLength]="16"></app-channel-text-input>
    </form>
    <form class="input-form">
        <app-channel-text-input
            #inputElement
            [value]="drawingId"
            [label]="'vessel.create.dialog.form.drawingId'"
            [name]="DRAWING_ID"
            [inputError]="validationErrors?.drawingId"
            [isDisabled]="!canEditAll && !isOwner && !isDuplicating"
            (onInputChange)="onInputChange($event)"
            (onFocusChange)="onInputChange($event)"
            [maxLength]="16"></app-channel-text-input>
    </form>
    <div class="row-container">
        <form class="input-form">
            <app-channel-text-input
                #inputElement
                type="text"
                [value]="numberOps"
                [label]="'vessel.create.dialog.form.ops'"
                [name]="NUMBER_OF_OPS"
                [inputError]="validationErrors?.numberOps"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [isDisabled]="!canEditAll && (isDuplicating || referenceVersion || createOption === RepurposeOption)"
                [maxLength]="2"></app-channel-text-input>
        </form>
        <form class="input-form">
            <app-channel-text-input
                #inputElement
                type="text"
                [value]="numberFcu"
                [label]="'vessel.create.dialog.form.fcu'"
                [name]="NUMBER_OF_FCU"
                [inputError]="validationErrors?.numberFcu"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [isDisabled]="!canEditAll && (isDuplicating || referenceVersion || createOption === RepurposeOption)"
                [maxLength]="2"></app-channel-text-input>
        </form>
    </div>
</ng-template>

<ng-template #buttonsContainer>
    <div class="buttons-container" [class.editing]="isEditing || isDuplicating">
        <div
            class="cancel button"
            data-cy="vessel-modal-back-button"
            (click)="goBack()"
            *ngIf="!canEditAll && !isEditing && !isDuplicating">
            {{ 'vessel.create.dialog.form.button.back' | translate }}
        </div>
        <div
            *ngIf="!isEditing && !isDuplicating"
            class="create button"
            data-cy="vessel-modal-create-button"
            (click)="createVessel()"
            [ngClass]="{ button_disabled: isCreateDisabled() }">
            {{ 'vessel.create.dialog.form.button.create' | translate }}
        </div>
        <div
            *ngIf="isEditing"
            class="create button"
            data-cy="vessel-modal-save-button"
            (click)="updateVessel()"
            [ngClass]="{ button_disabled: isCreateDisabled() }">
            {{ 'vessel.create.dialog.form.button.update' | translate }}
        </div>

        <div
            *ngIf="isDuplicating"
            class="create button"
            data-cy="vessel-modal-duplicate-button"
            (click)="createVessel()"
            [ngClass]="{ button_disabled: isCreateDisabled() }">
            {{ 'vessel.create.dialog.form.button.duplicate' | translate }}
        </div>
    </div>
</ng-template>
